{
  "label": "Trails",
  "on": "Show",
  "off": "Hide",
  "help": "How to read trails",
  "legend": "Red dashes are footpaths, brown dashes are tracks. Zoom in to level 12 or more to see."
}
